import React from 'react';
import { Header, Footer } from '../components/layout';
import { ShieldCheck, FileText } from 'lucide-react';

export const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col justify-between bg-slate-50 dark:bg-slate-950 transition-colors">
      <Header />
      <main className="flex-1 max-w-4xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl shadow-sm p-8 space-y-6">
          <div className="flex items-center gap-3 border-b border-slate-200 dark:border-slate-800 pb-6">
            <div className="w-12 h-12 rounded-xl bg-emerald-100 dark:bg-emerald-950/60 flex items-center justify-center text-emerald-600 dark:text-emerald-400">
              <ShieldCheck className="w-6 h-6" />
            </div>
            <div>
              <h1 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-slate-100">
                Privacy Policy
              </h1>
              <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">
                Zero passive browsing tracking. Zero selling of user data.
              </p>
            </div>
          </div>

          <div className="space-y-4 text-sm text-slate-700 dark:text-slate-300 leading-relaxed">
            <h2 className="text-base font-semibold text-slate-900 dark:text-slate-100">
              1. Information We Collect
            </h2>
            <p>
              PriceLoss collects only the specific product URLs you explicitly submit for tracking. We do not monitor your active browsing history, tab switches, cart contents, or checkout behavior.
            </p>

            <h2 className="text-base font-semibold text-slate-900 dark:text-slate-100">
              2. Account Information
            </h2>
            <p>
              When creating an account, we collect your email address and an argon2id-hashed representation of your password solely for authentication and price drop alert dispatching.
            </p>

            <h2 className="text-base font-semibold text-slate-900 dark:text-slate-100">
              3. Data Retention
            </h2>
            <p>
              Historical price observations recorded by our system are retained for aggregated price trend analysis. You may delete individual watches or your entire account at any time.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export const TermsPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col justify-between bg-slate-50 dark:bg-slate-950 transition-colors">
      <Header />
      <main className="flex-1 max-w-4xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl shadow-sm p-8 space-y-6">
          <div className="flex items-center gap-3 border-b border-slate-200 dark:border-slate-800 pb-6">
            <div className="w-12 h-12 rounded-xl bg-blue-100 dark:bg-blue-950/60 flex items-center justify-center text-blue-600 dark:text-blue-400">
              <FileText className="w-6 h-6" />
            </div>
            <div>
              <h1 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-slate-100">
                Terms of Service
              </h1>
              <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">
                Terms governing consumer use of PriceLoss price monitoring
              </p>
            </div>
          </div>

          <div className="space-y-4 text-sm text-slate-700 dark:text-slate-300 leading-relaxed">
            <h2 className="text-base font-semibold text-slate-900 dark:text-slate-100">
              1. Service Scope
            </h2>
            <p>
              PriceLoss provides automated price observation and notification tools for informational purposes. While we strive for maximum accuracy, retailer prices fluctuate rapidly and final checkout price is governed by the respective retailer.
            </p>

            <h2 className="text-base font-semibold text-slate-900 dark:text-slate-100">
              2. Acceptable Use
            </h2>
            <p>
              Users agree not to submit malicious URLs, exploit crawler resources, or attempt denial-of-service against our infrastructure or third-party retailer hosts.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
